import * as React from 'react';
import { createElement } from 'react';
import { Button, Card, Dialog, Table, Notification } from '@alifd/next';
import { set, toPairs, isEmpty } from 'lodash-es';
import request from '@/utils/request';
import { workflowStore } from '@/store';
import { useLocalObservable, observer } from 'mobx-react';
const Submit = observer((props) => {
    const { documentId } = useLocalObservable(() => workflowStore);
    const [okLoading, setOkLoading] = React.useState(false);
    const nextNodesRef = React.useRef({});
    const defaultNextNodesRef = React.useRef({});
    const { validateForms, getFormValues, processType, opinionFormInstance, displayName, tabhelper, formId, } = props;
    const [disabled, setDisabled] = React.useState(true);
    const [visible, setVisible] = React.useState(false);
    const { userId } = JSON.parse(sessionStorage.getItem('userInfo')) || {};
    const [submitLoading, setSubmitLoading] = React.useState(false);
    const comment = React.useRef({});
    const [nextNodes, setNextNodes] = React.useState([]);
    const getComment = () => {
        return comment.current;
    };
    const getForm = () => {
        return getFormValues();
    };
    const submit = () => {
        setSubmitLoading(true);
        opinionFormInstance?.validate(async (error, values) => {
            if (!error) {
                comment.current = values;
                await validateForms().then(async (passed) => {
                    if (passed) {
                        await queryNextActors();
                    }
                    else {
                        setSubmitLoading(false);
                    }
                });
            }
            else {
                setSubmitLoading(false);
            }
        });
    };
    const handleOk = () => {
        setOkLoading(true);
        const rowsData = { ...nextNodesRef.current, ...defaultNextNodesRef.current };
        const nextActors = toPairs(rowsData).map((item) => {
            const [taskDefKey, value] = item;
            const { nodes = [] } = value;
            return {
                taskDefKey,
                assignees: nodes,
            };
        });
        request
            .post('/api/process/start', {
            formId,
            formData: JSON.stringify(getForm()),
            processName: '测试流程',
            comment: getComment(),
            processType,
            nextNode: {
                completeFirst: true,
                initiator: userId,
                nextActors,
            },
            flowAttachment: '',
            bizDocListId: documentId,
        })
            .then(() => {
            Notification.success({
                title: '发起成功',
            });
            setVisible(false);
            tabhelper?.closeTab();
        })
            .finally(() => {
            setSubmitLoading(false);
            setOkLoading(false);
        });
    };
    const onChange = (rows) => {
        nextNodesRef.current = rows;
        toggleDisabled();
    };
    const toggleDisabled = () => {
        const _disabled = isEmpty(nextNodesRef.current) && isEmpty(defaultNextNodesRef.current);
        setDisabled(_disabled);
    };
    const handleCancel = () => {
        setVisible(false);
        setSubmitLoading(false);
    };
    const queryNextActors = React.useCallback(async () => {
        await request('/api/process/task/initiate/next/actors', {
            params: { processType, completeFirst: true, variables: null },
        })
            .then(({ content = [] }) => {
            const defaultSelectedNodes = content.filter((item) => item.assignMode === 'AUTO_ANYONE');
            defaultSelectedNodes.forEach((item) => {
                const { taskDefKey, defaultAssignees } = item;
                set(defaultNextNodesRef.current, taskDefKey, { nodes: defaultAssignees });
            });
            setVisible(true);
            setNextNodes(content);
            toggleDisabled();
        })
            .catch(() => {
            setSubmitLoading(false);
        });
    }, [processType]);
    return (createElement("div", null,
        createElement(Button, { onClick: submit, loading: submitLoading }, displayName),
        createElement(Dialog, { v2: true, title: "\u4E0B\u4E00\u8282\u70B9\u5904\u7406\u4EBA", visible: visible, onOk: handleOk, onCancel: handleCancel, width: 1000, okProps: {
                loading: okLoading,
                disabled,
            }, closeMode: ['close', 'esc', 'mask'], onClose: handleCancel },
            createElement(NextNodesList, { onChange: onChange, nextNodes: nextNodes }))));
});
export default Submit;
const NextNodesList = ({ onChange, nextNodes = [], }) => {
    const rowsData = React.useRef({});
    const emitRows = React.useCallback(() => {
        onChange(rowsData.current);
    }, [onChange]);
    const columns = [
        {
            title: '用户名称',
            dataIndex: 'userName',
            key: 'userName',
        },
        {
            title: '部门',
            dataIndex: 'departmentName',
            key: 'departmentName',
        },
    ];
    const getCheckboxProps = (record, assignMode, defaultAssignees = []) => {
        if (assignMode === 'AUTO_ANYONE') {
            const checked = defaultAssignees && defaultAssignees.find((item) => item.userId === record.userId);
            return {
                disabled: true,
                checked,
            };
        }
        return {};
    };
    const onSelectedChange = (selectedRowKeys, selectedRows, taskDefKey) => {
        set(rowsData.current, taskDefKey, { nodes: selectedRows });
        emitRows();
    };
    return (createElement("div", null, nextNodes.map((item) => {
        const { assignMode, assignees = [], defaultAssignees = [], taskDefKey, taskDefName } = item;
        const mul = assignMode.startsWith('CS');
        return (createElement(Card, { title: taskDefName, key: taskDefKey },
            createElement(Table, { columns: columns, dataSource: assignees, rowSelection: {
                    mode: mul ? 'multiple' : 'single',
                    onChange: (selectedRowKeys, selectedRows) => onSelectedChange(selectedRowKeys, selectedRows, taskDefKey),
                    getProps: (record) => getCheckboxProps(record, assignMode, defaultAssignees),
                }, primaryKey: "userId" })));
    })));
};
